module.exports = __webpack_public_path__ + "img/4.2c78b5c4.png";